module.exports = __webpack_public_path__ + "img/logo-dark.1393f806.png";